import { ApolloClient, InMemoryCache, HttpLink, from } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
const GraphqlClient = () => {
  const errorLink = onError(({
    networkError
  }) => {});
  const httpLink = from([errorLink, new HttpLink({
    credentials: 'include',
    uri: "./graphql"
  })]);
  const authLink = setContext((_, {
    headers
  }) => {
    // get the authentication token from local storage if it exists
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers
      }
    };
  });
  return new ApolloClient({
    credentials: 'include',
    link: authLink.concat(httpLink),
    cache: new InMemoryCache({})
  });
};
export default GraphqlClient;